import { useEffect, useState } from 'react';

// Detects the visitor's mobile platform on the client. Returns 'android',
// 'ios' or 'other'. Starts as 'other' so prerendered HTML stays neutral and
// hydration never mismatches.
export default function usePlatform() {
  const [platform, setPlatform] = useState('other');

  useEffect(() => {
    const ua = navigator.userAgent || '';
    const uaData = navigator.userAgentData;
    if (uaData && uaData.platform === 'Android') { setPlatform('android'); return; }
    if (/android/i.test(ua)) { setPlatform('android'); return; }
    // iPadOS 13+ reports as Macintosh but is touch-capable.
    if (/iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) {
      setPlatform('ios');
    }
  }, []);

  return platform;
}
